import { useEffect, useState } from 'react';
import type { Choice, IdentifiedChoiceResult } from '../types';

interface useIdentifiedResultsListStateProps {
  choices: Choice[];
  identifiedResults: IdentifiedChoiceResult[];
  shouldHideResults: boolean;
}

export const useIdentifiedResultsListState = ({
  choices,
  identifiedResults,
  shouldHideResults,
}: useIdentifiedResultsListStateProps) => {
  const [identitiesListChoiceId, setIdentitiesListChoiceId] = useState<
    Choice['id'] | null
  >(null);

  useEffect(() => {
    if (shouldHideResults) {
      setIdentitiesListChoiceId(null);
    }
  }, [shouldHideResults, setIdentitiesListChoiceId]);

  const identityListChoice = choices.find(
    (c) => c.id === identitiesListChoiceId,
  );
  const identityListChoiceIndex = choices.findIndex(
    (c) => c.id === identitiesListChoiceId,
  );
  const activeChoiceIdentities = identifiedResults?.find(
    (option) => option.choiceId === identitiesListChoiceId,
  );

  return {
    setIdentitiesListChoiceId,
    identityListChoice,
    identityListChoiceIndex,
    activeChoiceIdentities,
  };
};
